import React from 'react';
import { SubmittableFragment } from '@philips-internal/oswald-ui-engine';
import { noop } from '@philips-internal/oswald-ui-utils';
import { foundationContext } from '../../../../index.js';
function ExternalContent() {
    const fragment = foundationContext.getMenuFragment();
    if (!fragment) {
        return null;
    }
    const fragmentProps = {
        disposable: true,
        fragment,
        instanceUUID: 'external-fragment-instance-uuid',
        onCancel: noop,
        onSubmit: noop,
        uuid: 'external-fragment-uuid',
    };
    return (React.createElement("div", { className: "c-spotlight__external-fragment" },
        React.createElement(SubmittableFragment, { ...fragmentProps })));
}
export { ExternalContent, };
//# sourceMappingURL=external-content.js.map